import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchBlackoutDates, addBlackoutDate } from "./BlackoutSlice";
import { Button } from "@mui/material";
import BlackoutCalendar from "./Calendar/BlackoutCalendar";

const BlackoutComponent = () => {
  const [selectedDate, setSelectedDate] = useState(null);

  const dispatch = useDispatch();
  // const blackoutDates = useSelector((state) => state.blackoutDates);

  useEffect(() => {
    dispatch(fetchBlackoutDates());
  }, [dispatch]);

  const handleDateChange = (date) => {
    console.log("Clicked on:", date);
    setSelectedDate(date);
  };

  function handleAddBlackoutDate() {
    if (!(selectedDate instanceof Date)) {
      console.error("selectedDate is not a valid Date object.");
      return;
    }
    if (!selectedDate) {
      console.warn("No date selected. Aborting.");
      return;
    }

    // Convert the selectedDate to a formatted string
    const formattedDate = `${selectedDate.getFullYear()}-${String(
      selectedDate.getMonth() + 1
    ).padStart(2, "0")}-${String(selectedDate.getDate()).padStart(2, "0")}`;

    // dispatch this date string
    console.log("Dispatching addBlackoutDate with payload:", formattedDate);
    dispatch(addBlackoutDate(formattedDate));
  }

  return (
    <div>
      <BlackoutCalendar onDateChange={handleDateChange} />
      <Button
        variant="contained"
        color="primary"
        onClick={() => handleAddBlackoutDate()}
        sx={{
          mt: 2,
          backgroundColor: "#1C611C", // Your green color code
          "&:hover": {
            backgroundColor: "#145a14", // A slightly darker green for hover state
          },
          display: "block", // This will allow us to use margin: 'auto'
          margin: "auto", // This will center the button
          width: "fit-content", // This will make sure the button width is only as wide as the text inside it
        }}
      >
        Add Blackout Date
      </Button>
    </div>
  );
};

export default BlackoutComponent;
